import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  addDoc,
  doc,
  documentId,
  updateDoc,
  setDoc,
  arrayUnion,
  DocumentReference,
  limit,
  Query,
  DocumentData,
  FieldPath,
  orderBy,
  and,
} from "firebase/firestore";

import { getState } from "../pinia/AppState";

import { defineStore } from "pinia";
import {
  getStorage,
  deleteObject,
  ref,
  getDownloadURL,
} from "firebase/storage";

import { SnapshotListener } from "@/utils/SnapshotListener";
import Employee from "@/model/Employees/Employee";
import * as Firebase from "@/firebase/Firebase";
import PunchCardEntry from "@/model/Employees/PunchCardEntry";
import EmployeePunchCard from "@/model/Employees/EmployeePunchCard";
import Store from "@/model/Store";
import { x } from "pdfkit";
import User from "@/model/User";

interface EmployeeManager {
  cache: Map<string, Employee>;
  cacheByDatabase: Map<string, Employee[]>;
}

export const getEmployeeManager = defineStore("EmployeesManager", {
  state: (): EmployeeManager => {
    return {
      cache: new Map<string, Employee>(),
      cacheByDatabase: new Map<string, Employee[]>(),
    };
  },
  actions: {
    async getEmployeePunchCard(
      employeeId: string,
      year: number
    ): Promise<EmployeePunchCard> {
      let ref = doc(
        Firebase.firestore,
        "employees",
        employeeId,
        "punch_cards",
        year.toString()
      );
      let document = await getDoc(ref);

      return EmployeePunchCard.fromFirestore(document);
    },
    async getEmployees(currentUser: User, store: Store): Promise<Employee[]> {
      if (currentUser.role == "customer") {
        let res = await getDocs(
          query(
            collection(Firebase.firestore, "employees"),
            and(where("stores", "array-contains", store.ref))
          )
        );

        var results = res.docs.map((x) => Employee.fromFirestore(x));
        return results.sort((a, b) => a.name.localeCompare(b.name));
      }
      if (this.cacheByDatabase.has(store.database)) {
        var results = this.cacheByDatabase.get(store.database)! as Employee[];

        results = results.filter((x) =>
          x.stores.some((x) => x.id == store.ref.id)
        );

        return results.sort((a, b) => a.name.localeCompare(b.name));
      }

      let res = await getDocs(
        query(
          collection(Firebase.firestore, "employees"),
          and(where("databases", "array-contains", store.database))
        )
      );

      var results = res.docs.map((x) => Employee.fromFirestore(x));
      for (let employee of results) {
        this.cache.set(employee.ref.id, employee);
      }

      var oldPath = store.ref.path + "/employees";

      let oldResults = await getDocs(
        query(collection(Firebase.firestore, oldPath))
      );

      var oldEmployees = oldResults.docs.map((x) => Employee.fromFirestore(x));

      for (let oldEmployee of oldEmployees) {
        if (
          results.some(
            (x) => x.old_ref != null && x.old_ref.id == oldEmployee.ref.id
          )
        ) {
          continue;
        } else {
          results.push(oldEmployee);
        }
      }

      this.cacheByDatabase.set(store.database, results);

      results = results.filter((x) =>
        x.stores.some((x) => x.id == store.ref.id)
      );

      return results.sort((a, b) => a.name.localeCompare(b.name));
    },
    async getEmployee(ref: DocumentReference): Promise<Employee> {
      var result = this.cache.get(ref.id!);

      if (result) {
        return result;
      }

      let doc = await getDoc(ref);
      var employee = Employee.fromFirestore(doc);
      this.cache.set(ref.id, employee);
      return employee;
    },
  },
});
